import React from 'react';

interface FormSkeletonProps {
  rowCount?: number;
}

const Skeleton = () => {
  return (
    <div className="space-y-4 animate-pulse mb-1">
      <div className="h-6 bg-gray-200 rounded-md w-3/4"></div>

      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded-md w-1/4"></div>
        <div className="h-10 bg-gray-200 rounded-md w-full"></div>
      </div>

      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded-md w-1/4 mb-2"></div>
        <div className="h-24 bg-gray-200 rounded-md w-full"></div>
      </div>

      <div className="h-10 bg-gray-200 rounded-md w-full"></div>
    </div>
  );
};

export const FormSkeleton: React.FC<FormSkeletonProps> = ({ rowCount = 1 }) => {
  const skeletons = Array.from({ length: rowCount }, (_, i) => (
    <Skeleton key={i} />
  ));
  return <div className="w-full"> {skeletons} </div>;
};

export default FormSkeleton;
